
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ProductFilterProps {
  value: string;
  onChange: (value: string) => void;
  productNames?: string[];
}

export function ProductFilter({ value, onChange, productNames = [] }: ProductFilterProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[180px] bg-white">
        <SelectValue placeholder="Filter by product" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Products</SelectItem>
        {productNames.map(name => (
          <SelectItem key={name} value={name.toLowerCase()}>{name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
